<template>
    <header class="header" :class="{'with-active-store': activeStore}"><div style="display: none !important;"><svg><symbols><symbol id="sprite-logo-atelier-fr"><path d="M55.44 135.01H0V.11h20.35v114.66h35.09zm-5-99.69a10.52 10.52 0 0 0 7.3-4.05q2.43-3.33 2.43-10.31h-9.73V1.21h18.34v18q0 10.47-4 15.92t-14.34 7.14zm117.75-14.75h-15.45L149.08.11h65.63v20.46h-26.17v114.44h-20.35zm187.98 114.44h-55.45V.11h20.35v114.66h35.1zM87.33 135.01h21.19l3.15-19.78H90.69l-3.36 19.78z"/><path d="M134.7 104.01l4.76 31h21.4L138.25.11h-28l-17.66 103.9m24-19.81l7.54-53.19 7.53 53.19zM228.81 135.01h57.92v-20.46h-37.58V77.73h27.46V57.27h-27.46V31.71h-20.34v103.3zm57.92-114.55V0h-57.92v20.5h20.34v-.04h37.58zm-37.58 11.25h.32m0-11.21h-.32m217.48-.04V0h-57.92v103.25h20.34V77.73h27.46V57.27h-27.46V20.46h37.58zm-57.92 114.55h57.92v-20.46h-37.58v-.09h-20.34v20.55zm140.17 0L537.7 88.23l-20.42 5.42 9.59 41.36h22.01z"/><path d="M533.81 76.12a31.51 31.51 0 0 0 10.87-24.22V32.27q0-14.64-7-22.82-8-9.37-25-9.37h-32.06v134.9h20.35V84.2h13.57a25.18 25.18 0 0 0 10.33-2.54 43.06 43.06 0 0 0 8.94-5.54zm-8.94-23.79a11.4 11.4 0 0 1-3.39 8.29 11.09 11.09 0 0 1-8.23 3.44h-12.28V20.89h12.28q11.63 0 11.62 11.74zM370.16.11h20.35v21.75h-20.35zm0 32.96h20.35v101.94h-20.35z"/></symbol><symbol id="sprite-logo-atelier-en"><path d="M542.568 8.937c-4.539-4.817-10.627-7.226-18.267-7.226h-24.744v104.043h15.694V17.738h9.465c2.712 0 4.884.829 6.519 2.491 1.631 1.661 2.448 3.848 2.448 6.559v15.195c0 2.491-.872 4.624-2.614 6.394-1.745 1.772-3.861 2.657-6.353 2.657h-.498v15.528h.083c6.809 0 12.606-2.435 17.394-7.307 4.79-4.871 7.184-10.739 7.184-17.603V26.539c0-7.14-2.104-13.008-6.311-17.602M173.745 24.961c0-2.491-.871-4.608-2.614-6.352-1.746-1.743-3.862-2.615-6.354-2.615-2.49 0-4.622.872-6.393 2.615-1.773 1.744-2.657 3.861-2.657 6.352v56.963c0 2.49.884 4.608 2.657 6.351 1.771 1.745 3.903 2.617 6.393 2.617 2.492 0 4.608-.872 6.354-2.617 1.743-1.743 2.614-3.861 2.614-6.351V24.961zM165.193.383c6.919 0 12.8 2.437 17.645 7.307 4.843 4.873 7.266 10.741 7.266 17.604V82.09c0 6.921-2.437 12.802-7.307 17.644-4.873 4.845-10.74 7.266-17.604 7.266-6.921 0-12.788-2.435-17.604-7.308-4.815-4.87-7.224-10.738-7.224-17.602V25.294c0-6.919 2.435-12.801 7.308-17.647 4.87-4.841 10.711-7.264 17.52-7.264zM412.426 37.113h15.693V1.711h-15.693z"/><path d="M393.495 45.887V1.711h-15.693v104.043h15.693V61.663h18.931v44.091h15.693V45.891l-34.624-.004M369.595 79.848c.11 7.253-1.773 13.451-5.647 18.599-2.545 3.489-6.144 5.952-10.794 7.391-2.492.774-5.397 1.162-8.719 1.162-6.144 0-11.239-1.521-15.278-4.566-3.377-2.492-6.049-5.881-8.013-10.172-1.966-4.29-3.114-9.203-3.447-14.739l14.948-1.08c.664 6.066 2.267 10.462 4.815 13.188 1.881 2.059 4.039 3.033 6.477 2.921 3.431-.11 6.172-1.801 8.22-5.07 1.051-1.606 1.578-3.906 1.578-6.898 0-4.321-1.965-8.616-5.896-12.882-3.1-2.935-7.75-7.34-13.949-13.213-5.204-5.042-8.885-9.559-11.044-13.548-2.325-4.488-3.488-9.363-3.488-14.626 0-9.475 3.183-16.651 9.549-21.527 3.93-2.937 8.802-4.405 14.615-4.405 5.59 0 10.379 1.245 14.364 3.737 3.101 1.938 5.605 4.65 7.516 8.137 1.909 3.489 3.058 7.502 3.446 12.04l-15.03 2.741c-.443-4.264-1.661-7.584-3.654-9.965-1.438-1.715-3.514-2.574-6.227-2.574-2.879 0-5.065 1.275-6.559 3.82-1.219 2.048-1.828 4.595-1.828 7.64 0 4.76 2.048 9.604 6.145 14.53 1.548 1.883 3.875 4.097 6.975 6.643 3.653 3.046 6.062 5.176 7.224 6.393 3.874 3.876 6.864 7.696 8.967 11.458.997 1.774 1.798 3.407 2.41 4.901 1.494 3.709 2.268 7.031 2.324 9.964M316.932 105.754l-20.97-51.32-10.1 18.94 12.622 32.38h18.448"/><path d="M313.221 1.628H296.49l-19.181 37.117V1.628h-15.693v104.126h15.693V72.748l4.697-9.267.012.03L291.74 44.1l21.481-42.472M252.985 105.627l-8.624-36.067-15.739 4.174 7.396 31.893h16.967"/><path d="M234.474 43.871c0 2.49-.872 4.622-2.615 6.392-1.743 1.772-3.86 2.657-6.35 2.657h-9.465V19.629h9.465c5.977 0 8.965 3.019 8.965 9.051v15.191zm6.89 18.346c5.589-5.09 8.384-11.317 8.384-18.679V28.431c0-7.526-1.8-13.395-5.396-17.6-4.096-4.815-10.515-7.224-19.259-7.224h-24.739v104.02h15.69V68.443h10.461s3.621.095 7.968-1.952c4.223-1.988 6.891-4.274 6.891-4.274zM471.746 24.961c0-2.491-.872-4.608-2.614-6.352-1.745-1.743-3.862-2.615-6.354-2.615-2.49 0-4.622.872-6.393 2.615-1.773 1.744-2.657 3.861-2.657 6.352v56.963c0 2.49.884 4.608 2.657 6.351 1.771 1.745 3.903 2.617 6.393 2.617 2.492 0 4.609-.872 6.354-2.617 1.742-1.743 2.614-3.861 2.614-6.351V24.961zM463.194.383c6.919 0 12.8 2.437 17.645 7.307 4.843 4.873 7.266 10.741 7.266 17.604V82.09c0 6.921-2.437 12.802-7.308 17.644-4.872 4.845-10.739 7.266-17.603 7.266-6.92 0-12.788-2.435-17.604-7.308-4.815-4.87-7.224-10.738-7.224-17.602V25.294c0-6.919 2.435-12.801 7.308-17.647 4.87-4.841 10.711-7.264 17.52-7.264zM134.4 1.711h-16.473l-3.344 24.442 7.8 52.371L134.4 1.711M110.311 57.381l-8.212-55.67H85.658L78.1 57.428 69.88 1.711H53.439l17.422 104.043h15.015l8.353-57.243 8.948 57.243h14.417l-7.245-48.647-.038.274M43.463 105.754v-39.29h11.273l1.013 5.952h-6.364v10.716h8.152l1.011 5.954h-9.163v10.715h10.936l1.01 5.953H43.463M27.137 89.117v16.637h-5.922v-39.26h5.922v16.67h7.144v-16.67h5.923v39.26h-5.923V89.117h-7.144M6.298 72.448H0v-5.954h18.486v5.954H12.22v33.306H6.298V72.448"/></symbol><symbol id="sprite-icon-mail"><path d="M1.615 0a1.61 1.61 0 0 0-.605.118l9.011 8.026a.672.672 0 0 0 .976 0L19.991.118A1.619 1.619 0 0 0 19.385 0H1.615zm-1.6 1.388a1.547 1.547 0 0 0-.017.227v10.77a1.612 1.612 0 0 0 .126.623l6.218-5.974zm20.966 0l-6.31 5.637L20.882 13a1.625 1.625 0 0 0 .118-.615V1.616a1.542 1.542 0 0 0-.017-.227zM13.46 8.11l-1.389 1.245a2.369 2.369 0 0 1-3.13 0L7.553 8.118l-6.125 5.873a1.82 1.82 0 0 0 .185.008h17.77c.059 0 .12 0 .176-.008z"/></symbol></symbols></svg></div>
        <div class="secondary-nav">
            <div class="grid-container flex-container align-right" v-if="activeStore">
                <small class="active-store">{{ activeStore.name }}</small>
            </div>
            <div class="grid-container flex-container align-middle align-justify">
                <router-link v-if="user && user.access_right_group !== 'Imagine'  && user.access_right_group !== 'Tactical'" :to="{ name: localizedRoute('Home') }" class="header-logo-link flex-container align-middle">
                    <svg inline="" class="header-logo-fr" v-if="currentLanguage === 'fr'" role="presentation" focusable="false" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.88 135.01"><use xlink:href="#sprite-logo-atelier-fr"></use></svg>
                    <svg inline="" class="header-logo-en" v-else="" role="presentation" focusable="false" viewBox="0 0 549 107" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#sprite-logo-atelier-en"></use></svg>
                    <div render-html="true" v-translate>BMR %{ br }Dealers’ Portal</div>
                </router-link>
                <router-link v-if="user && user.access_right_group === 'Imagine'  && user.access_right_group !== 'Tactical'" :to="{ name: 'StaticList-'+currentLanguage, params: { type:  currentLanguage === 'fr' ? 'planographie' : 'planograms' } }" class="header-logo-link flex-container align-middle">
                    <svg inline="" class="header-logo-fr" v-if="currentLanguage === 'fr'" role="presentation" focusable="false" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.88 135.01"><use xlink:href="#sprite-logo-atelier-fr"></use></svg>
                    <svg inline="" class="header-logo-en" v-else="" role="presentation" focusable="false" viewBox="0 0 549 107" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#sprite-logo-atelier-en"></use></svg>
                    <div render-html="true" v-translate>BMR %{ br }Dealers’ Portal</div>
                </router-link>
                <router-link v-if="user && user.access_right_group !== 'Imagine'  && user.access_right_group === 'Tactical'" :to="{ name: 'SingleStaticDetail-'+currentLanguage, params: { type:  'accord-d' } }" class="header-logo-link flex-container align-middle">
                    <svg inline="" class="header-logo-fr" v-if="currentLanguage === 'fr'" role="presentation" focusable="false" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.88 135.01"><use xlink:href="#sprite-logo-atelier-fr"></use></svg>
                    <svg inline="" class="header-logo-en" v-else="" role="presentation" focusable="false" viewBox="0 0 549 107" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#sprite-logo-atelier-en"></use></svg>
                    <div render-html="true" v-translate>BMR %{ br }Dealers’ Portal</div>
                </router-link>
                <div class="flex-container align-middle align-justify">
                    <form v-if="user && user.access_right_group !== 'Imagine' && user.access_right_group !== 'Tactical'"  action="" method="get" class="menu-item search-wrapper show-for-medium">
                        <input class="search-input" type="search" v-model.trim="searchValue" :placeholder="t['Search']" @focus="searchOpened = true" @click.stop />
                    </form>
                    <div class="flex-container align-middle">
                        <router-link v-if="user && user.access_right_group !== 'Imagine' && user.access_right_group !== 'Tactical'"  :to="{ name: localizedRoute('NotificationList')}" class="menu-item">
                            <svg inline="" aria-describedby="messageCount" width="21" height="22" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 14"><use xlink:href="#sprite-icon-mail"></use></svg>
                            <span class="badge badge-alt" id="messageCount" v-if="notificationCount !== null">{{ notificationCount }}</span>
                        </router-link>
                        <user-menu></user-menu>
                    </div>
                </div>
            </div>
        </div>
        <nav class="primary-nav">
            <div class="flex-container">
                <button type="button" class="btn btn-menu show-for-small-only" @click="menuOpened = !menuOpened" v-translate>Menu</button>
                <form action="" method="get" class="menu-item search-wrapper">
                    <input class="search-input" type="search" v-model.trim="searchValue" :placeholder="t['Search']" @focus="searchOpened = true" @click.stop />
                </form>
            </div>
            <div class="grid-container" v-show="menuOpened">
                <ul class="flex-container text-center primary-nav-list no-bullet" :class="user && user.access_right_group !== 'Imagine' ? 'align-center' : ''">
                    <menu-item
                        v-for="(menuItem, index) in filteredMenuItems"
                        :menu-item="menuItem"
                        :key="`menu-${index}`"
                        @close="close"
                    ></menu-item>
                </ul>
            </div>
        </nav>

        <search-results v-if="searchOpened && searchValue !== ''" :keyword="searchValue" @close="searchOpened = false"></search-results>
    </header>
</template>


<script>
import MenuItem from './MenuItem';
import UserMenu from './UserMenu';
import SearchResults from './SearchResults';

import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('bmr');

export default {
    name: 'AppHeader',
    components: {
        UserMenu,
        MenuItem,
        SearchResults,
    },
    data () {
        return {
            searchOpened: false,
            searchValue: '',
            menuOpened: false,
            br: '<br />',
            menuElements: [],
        };
    },
    computed: {
        ...mapState(['activeStore', 'notificationCount', 'user', 'menuItems']),
        ...mapGetters(['isLoggedIn']),
        t () {
            return {
                'Search': this.$gettext('Search'),
            };
        },
        filteredMenuItems () {
            return this.menuItems.filter(s => s.title !== null && s.position > 0);
        }
    },
    created () {
        if (this.isLoggedIn) {
            this.loadMenuElements();
            this.loadNotificationCount();
        }
    },
    methods : {
        ...mapActions(['loadNotificationCount', 'loadMenuElements']),
        close () {
            this.menuOpened = false;
        },
    }
};
</script>
<style lang="scss" scoped>
.header {
    position: relative;
}
.header-logo-fr {
    height: 28px;
    width: 98px;
    @include breakpoint(medium) {
        height: 40px;
        width: 138px;
    }
}
.header-logo-en {
    height: 28px;
    width: 147px;
    @include breakpoint(medium) {
        height: 40px;
        width: 206px;
    }
}
.header-logo-link {
    flex-shrink: 0;
    .with-active-store & {
        @include breakpoint(medium) {
            margin-top: -20px;
        }
    }
    div {
        @include rem-typo(10px);
        display: none;
        color: $white;
        font-weight: 600;
        margin-left: 16px;
        text-transform: uppercase;
        @include breakpoint(450px) {
            display: block;
        }
        @include breakpoint(medium) {
            @include rem-typo(12px);
        }
    }
}
.secondary-nav {
    padding: 20px 0;
    background-color: $c-atelier;
    min-height: 70px;
    @include breakpoint(medium) {
        min-height: 80px;
    }
}
.menu-item {
    @include rem-typo(14px);
    line-height: 1.5;
    position: relative;
    margin-left: 15px;
    text-transform: uppercase;;
    color: $white;
    font-family: $f-oswald;
    user-select: none;
    @include breakpoint(medium) {
        margin-left: 25px;
    }
}
.primary-nav {
    background-color: $c-atelier-dark;
    .grid-container {
        padding-top: 0.5rem;
        padding-bottom: 1rem;
        background-color: #232323;
        padding-left: 0;
        padding-right: 0;
        @include breakpoint(medium) {
            display: block !important;
            padding-top: 0;
            padding-bottom: 0;
            background-color: $c-atelier-dark;
        }
        @include breakpoint(large) {
            padding-right: 1.2rem;
            padding-left: 1.2rem;
        }
        .flex-container {
            @media (max-width: 1325px) {
                flex-wrap: wrap;
            }
        }
    }
    .search-wrapper {
        width: 60%;
        .search-input {
            background: transparentize($black, 0.7);
        }
        @include breakpoint(medium) {
            display: none;
        }
    }
}
.primary-nav-list {
    flex-direction: column;
    @include breakpoint(medium) {
        flex-direction: row;
    }
}
.search-wrapper {
    position: relative;
    margin: 0;
    &::after {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-image: url("~@/assets/svg/icon-search.svg");
        background-repeat: no-repeat;
        background-size: contain;
    }
}
.search-input {
    @include rem-typo(16px);
    margin: 0;
    border-radius: 2px;
    background-color: $c-atelier-dark;
    padding: 16px;
    padding-right: 40px;
    border: 0;
    color: $white;
    transition: all 300ms ease;
    border-radius: 0;
    min-height: 40px;
    &:focus {
        box-shadow: none;
    }
    @include breakpoint(medium) {
        @include rem-typo(13px);
        color: $c-atelier-light;
        background-color: transparentize($black, 0.7);
        width: 170px;
        &:focus {
            width: 240px;
            transition: all 300ms ease;
        }
    }
    &::placeholder {
        font-style: italic;
        color: currentColor;
    }
}
.badge {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    border-radius: 99px;
    color: $black;
    font-weight: 600;
    box-shadow: 0 0 0 2px $c-atelier;
    padding: 1px;
}
.btn-menu {
    @include rem-typo(18px);
    font-family: $f-oswald;
    letter-spacing: 1px;
    width: 40%;
    min-width: 120px;
    text-transform: uppercase;
    color: $solid-white;
    font-weight: 700;
    padding: 6px 8px;
    text-align: center;
    justify-content: center;
    min-height: 40px;
    &:focus {
        outline: none;
    }
}
svg {
    display: block;
    fill: $white;
}
.active-store {
    color: $white;
    margin-bottom: 8px;
    margin-top: -8px;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Header.vue